package io.horion.auth.api.models.domain

import kotlinx.serialization.Serializable

@Serializable
data class RegisterRequest(
    val email: String? = null,
    val phone: String? = null,
    val password: String = "",
)
